<template>
	<div id="app">
		<nav class="w-full bg-red-700 px-12 py-4 text-white flex justify-between items-center">
			<div><a href="/">ChinaPersecution.org</a></div>
			<div class="flex justify-around items-center max-w-lg w-full uppercase">
				<!-- <div><a href="/">Home</a></div> -->
				<!-- <div class="border-r border-l w-1/3 text-center"><a href="/">Stories</a></div> -->
				<!-- <div><a href="/about">About</a></div> -->
			</div>
			<div><a href="mailto:pastorstevehopkins@gmail.com">Contact&nbsp;Us</a></div>
		</nav>
		<router-view/>
		<!-- <div id="nav" class="h-12 flex items-center justify-between footer-shadow px-4 sm:px-8">
			<div class="flex items-center text-gray-800 text-sm">
				© {{ new Date().getFullYear() }} ChinaPersecution
			</div>
		</div> -->
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

export default {

}
</script>

<style>
@import "tailwindcss/base";
@import "tailwindcss/components";
@import "tailwindcss/utilities";

.footer-shadow {
	box-shadow: -1px -5px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
	-webkit-box-shadow: -1px -5px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
</style>
